import React, { Component } from "react";
import { variables } from "./Variables.js";
import DeckExport from "./component/DeckExport.js";
import { v4 as uuid } from "uuid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Papa from "papaparse";
import {
  faSquareMinus,
  faSquarePlus,
  faEyeSlash,
  faQuestionCircle,
  faTrashAlt,
} from "@fortawesome/free-regular-svg-icons";
import ImageComponent from "./component/ImageComponent";
import { faTrashCanArrowUp } from "@fortawesome/free-solid-svg-icons";
import SearchBar from "rsuite/esm/Picker/SearchBar.js";

//import { DeckList } from "./DeckList";

export class Deckbuilder extends Component {
  constructor(props) {
    super(props);

    this.state = {
      cardList: [],
      firstHand: [],
      cardExcel: [],
      DCards: variables.deckcards,
      ICards: variables.itemcards,
      Colors: [],
      deckDisplay: [],
      itemDisplay: [],
      buttonFilter: "",
      Name: "",
      cardsWithoutFilter: [],
      PhotoPath: variables.PHOT_URL,
      deckSizeLimit: 30,
    };
  }

  changeNameFilter = (e) => {
    this.state.NameFilter = e.target.value;
    this.FilterFn();
  };

  addCardtoArray = (e) => {
    //filteredData will just have the new card
    var filteredData = this.state.cardsWithoutFilter.filter(function (el) {
      return el.UniqueName?.toString()
        .toLowerCase()
        .startsWith(e.toString().trim().toLowerCase());
    });
    //If the card is an Doctrine, put in Doctrine row
    if (filteredData.length > 0) {
      if (
        filteredData[0].CardType.toString().toLowerCase().includes("doctrine")
      ) {
        var ItemC = [
          {
            UniqueName: filteredData[0].UniqueName,
            guid: uuid(),
            NAME: filteredData[0].NAME,
            URLLINK: filteredData[0].URLLINK,
            CardFaction: filteredData[0].CardFaction,
            CardType: filteredData[0].CardType,
            Cost: filteredData[0].Cost,
            ATK: filteredData[0].ATK,
            Def: filteredData[0].Def,
            Hp: filteredData[0].Hp,
            BACKURL: filteredData[0].BACKURL,
            HS: filteredData[0].HS,
            CARDLIMIT: filteredData[0].CARDLIMIT,
            ATT: filteredData[0].ATTRIBUTES,
          },
        ];
        var maxICard = this.state.ICards.filter(function (el) {
          return el.Name?.toString()
            .toLowerCase()
            .includes(ItemC[0].Name.toString().trim().toLowerCase());
        });

        if (this.state.ICards.length === 0) {
          if (maxICard.length < 1) {
            this.state.ICards.push(ItemC[0]);

            var newvar2 = this.state.ICards;
            variables.itemcards = newvar2;
            this.setState({ ICards: newvar2 });
            this.sortItemResult("UniqueName");
          }
        }
      } else {
        if (this.state.DCards.length < this.state.deckSizeLimit) {
          var DeckC = [
            {
              UniqueName: filteredData[0].UniqueName,
              guid: uuid(),
              NAME: filteredData[0].NAME,
              URLLINK: filteredData[0].URLLINK,
              CardType: filteredData[0].CardType,
              CardFaction: filteredData[0].CardFaction,
              Cost: filteredData[0].Cost,
              ATK: filteredData[0].ATK,
              Def: filteredData[0].Def,
              Hp: filteredData[0].Hp,
              BACKURL: filteredData[0].BACKURL,
              CARDLIMIT: filteredData[0].CARDLIMIT,
              ATT: filteredData[0].ATTRIBUTES,
            },
          ];

          var maxCard = this.state.DCards.filter(function (el) {
            return el.UniqueName?.toString()
              .toLowerCase()
              .startsWith(DeckC[0].UniqueName.toString().trim().toLowerCase());
          });

          // var CardType = this.state.DCards.filter(
          //   (item) => (item.UniqueName = DeckC[0].UniqueName)
          // ).map((item) => item.CardType);
          var cardLimit = DeckC[0].CARDLIMIT.toString() || 3;

          // if (
          //   this.state.DCards.filter(function (el) {
          //     return el.CardType?.toString()
          //       .toLowerCase()
          //       .includes("home world");
          //   }).length > 0 &&
          //   DeckC[0].CardType?.toString().toLowerCase().includes("home world")
          // ) {
          //   cardLimit = 0;
          // }

          if (maxCard.length < cardLimit) {
            this.state.DCards.push(DeckC[0]);

            var newvar2 = this.state.DCards;

            variables.deckcards = newvar2;
            this.setState({ DCards: newvar2 });

            document.getElementById("cardCount").innerHTML = parseInt(
              this.state.DCards.length
            );

            this.sortCardResult("UniqueName");
          }
        }
      }
      this.deckDisplay();
    }
  };

  deckDisplay() {
    //Main Deck
    var deck = variables.deckcards;
    var deckSort = deck.map((Deck) => ({
      NAME: Deck.NAME,
      UniqueName: Deck.UniqueName,
      URLLINK: Deck.URLLINK,
      CardType: Deck.CardType,
      Count: 0,
    }));

    var deckFiltered = deckSort.filter(
      (v, i, a) => a.findIndex((v2) => v2.UniqueName === v.UniqueName) === i
    );

    deckFiltered.forEach(function (i) {
      i.Count = deck.filter(
        (obj) => obj.UniqueName === i.UniqueName.toString()
      ).length;
    });
    //Doctrine
    var item = variables.itemcards;
    var itemSort = item.map((item) => ({
      NAME: item.NAME,
      UniqueName: item.UniqueName,
      ID: item.UniqueName,
      URLLINK: item.URLLINK,
      BACKURL: item.BACKURL,
      CardType: item.CardType,
      Count: 0,
    }));

    var itemFiltered = itemSort.filter(
      (v, i, a) => a.findIndex((v2) => v2.UniqueName === v.UniqueName) === i
    );

    itemFiltered.forEach(function (i) {
      i.Count = item.filter(
        (obj) => obj.UniqueName === i.UniqueName.toString()
      ).length;
    });

    this.updateDeckStats();
    this.setState({ deckDisplay: deckFiltered });
    this.setState({ itemDisplay: itemFiltered });
  }

  updateDeckStats() {
    var deckStats = document.getElementById("divDeckStats");
    deckStats.innerHTML = "";

    var deck = variables.deckcards;
    var deckLength = deck.length;

    //Number of Tactics
    var tacticCount = deck.reduce(
      (acc, cur) => (cur.CardType.includes("Tactic") ? ++acc : acc),
      0
    );
    //Number of Territories
    var territoryCount = deck.reduce(
      (acc, cur) => (cur.CardType.includes("Territory") ? ++acc : acc),
      0
    );
    //Number of traps
    var trapCount = deck.reduce(
      (acc, cur) => (cur.CardType.includes("Trap") ? ++acc : acc),
      0
    );
    //Number of unitcedure
    var unitCount = deck.reduce(
      (acc, cur) => (cur.CardType.includes("Unit") ? ++acc : acc),
      0
    );

    var costAvg = 0;
    var powerAvg = 0;
    var defAvg = 0;
    if (tacticCount) {
      deckStats.innerHTML = "Tactic Count: " + tacticCount;
    }
    //Number of territorys
    if (territoryCount) {
      deckStats.innerHTML += "<br/> Territory Count: " + territoryCount;
    }
    //trap Count
    if (trapCount) {
      deckStats.innerHTML += "<br/> Trap Count: " + trapCount;
    }
    //unit Count
    if (unitCount) {
      deckStats.innerHTML += "<br/> Unit Count: " + unitCount;
    }

    //Average Cost
    var filteredData = deck.filter((e) => e.Cost != "");
    costAvg =
      filteredData.reduce(
        (r, c) => r + parseInt(c.Cost.toString().replace("*", 0)),
        0
      ) / filteredData.length;
    if (costAvg) {
      deckStats.innerHTML +=
        "<br/> Average Cost: " + costAvg.toString().substring(0, 4);
    }

    //Average Power
    var filteredData = deck.filter((e) => e.ATK != "");
    powerAvg =
      filteredData.reduce(
        (r, c) => r + parseInt(c.ATK.toString().replace("*", 0)),
        0
      ) / filteredData.length;
    if (powerAvg) {
      deckStats.innerHTML +=
        "<br/> Average ATK: " + powerAvg.toString().substring(0, 4);
    }

    //Average def
    var filteredData2 = deck.filter((e) => e.Def != "");
    defAvg =
      filteredData2.reduce(
        (r, c) => r + parseInt(c.Def.toString().replace("*", 0)),
        0
      ) / filteredData.length;
    if (defAvg) {
      deckStats.innerHTML +=
        "<br/> Average Def: " + defAvg.toString().substring(0, 4);
    }

    //Average hp
    var filteredData3 = deck.filter((e) => e.Hp != "");
    defAvg =
      filteredData3.reduce(
        (r, c) => r + parseInt(c.Hp.toString().replace("*", 0)),
        0
      ) / filteredData.length;
    if (defAvg) {
      deckStats.innerHTML +=
        "<br/> Average Hp: " + defAvg.toString().substring(0, 4);
    }
  }

  calcDeckStats() {
    var deck = variables.deckcards;
    document.getElementById("cardCount").innerHTML = deck.length;
  }

  removeCardfromArray = (e) => {
    var deckFilterArray = this.state.DCards.filter(function (del) {
      return del.UniqueName === e;
    });

    var removedCard = deckFilterArray[0].guid.toString();

    deckFilterArray = this.state.DCards.filter(function (del) {
      return del.guid !== removedCard;
    });

    //this.setState({DCards:deckFilterArray})
    variables.deckcards = [...deckFilterArray];
    this.state.DCards = deckFilterArray;
    document.getElementById("cardCount").innerHTML = this.state.DCards.length;
    this.deckDisplay();
  };

  removeItemfromArray = (e) => {
    var deckFilterArray = this.state.ICards.filter(function (del) {
      return del.UniqueName === e;
    });

    var removedCard = deckFilterArray[0].guid.toString();

    deckFilterArray = this.state.ICards.filter(function (del) {
      return del.guid !== removedCard;
    });

    variables.itemcards = [...deckFilterArray];
    this.deckDisplay();
    this.setState({ ICards: deckFilterArray });
  };

  sortItemResult(prop) {
    var sortData = this.state.ICards;

    var sortedData = sortData.sort(function (a, b) {
      return a[prop] > b[prop] ? 1 : a[prop] < b[prop] ? -1 : 0;
    });

    this.setState({ ICards: sortedData });
  }

  sortCardResult(prop) {
    var sortData = this.state.DCards;

    var sortedData = sortData.sort(function (a, b) {
      return a[prop] > b[prop] ? 1 : a[prop] < b[prop] ? -1 : 0;
    });

    this.setState({ DCards: sortedData });
  }

  sortResult(prop, asc) {
    var sortData = this.state.deckDisplay;

    var sortedData = sortData.sort(function (a, b) {
      if (asc) {
        return a[prop] > b[prop] ? 1 : a[prop] < b[prop] ? -1 : 0;
      } else {
        return b[prop] > a[prop] ? 1 : b[prop] < a[prop] ? -1 : 0;
      }
    });

    this.setState({ deckDisplay: sortedData });
  }

  refreshList() {
    this.state.buttonFilter = "";
    this.state.NameFilter = "";
    this.fetchGoogleSheetData();
  }

  FilterFn() {
    var NameFilter = this.state.NameFilter;
    var filterArray = NameFilter.split(",");

    if (NameFilter.toString().includes(",")) {
      var multiFilterArray = [];

      filterArray.forEach((i, indx) => {
        if (i.toString().toLowerCase().includes("fact:")) {
          i = i.replace("fact:", "");
          //Tag
          var filteredData = this.state.cardsWithoutFilter.filter(function (
            el
          ) {
            return el.CardFaction?.toString()
              .toLowerCase()
              .includes(i.toString().trim().toLowerCase());
          });
          multiFilterArray = multiFilterArray.concat(filteredData);
        } else if (i.toString().toLowerCase().includes("cardt:")) {
          //Card Type
          i = i.replace("cardt:", "");
          var filteredData = this.state.cardsWithoutFilter.filter(function (
            el
          ) {
            return el.CardType?.toString()
              .toLowerCase()
              .includes(i.toString().trim().toLowerCase());
          });
          multiFilterArray = multiFilterArray.concat(filteredData);
        } else if (i.toString().toLowerCase().includes("cost:")) {
          //Archtype Color Type
          i = i.replace("cost:", "");
          var filteredData = this.state.cardsWithoutFilter.filter(function (
            el
          ) {
            return el.Cost?.toString()
              .toLowerCase()
              .includes(i.toString().trim().toLowerCase());
          });
          multiFilterArray = multiFilterArray.concat(filteredData);
        } else if (i.toString().toLowerCase().includes("atk:")) {
          //Color
          i = i.replace("atk:", "");
          var filteredData = this.state.cardsWithoutFilter.filter(function (
            el
          ) {
            return el.ATK?.toString()
              .toLowerCase()
              .includes(i.toString().trim().toLowerCase());
          });
          multiFilterArray = multiFilterArray.concat(filteredData);
        } else if (i.toString().toLowerCase().includes("def:")) {
          //Color Type
          i = i.replace("def:", "");
          var filteredData = this.state.cardsWithoutFilter.filter(function (
            el
          ) {
            return el.Def?.toString()
              .toLowerCase()
              .includes(i.toString().trim().toLowerCase());
          });
          multiFilterArray = multiFilterArray.concat(filteredData);
        } else if (i.toString().toLowerCase().includes("hp:")) {
          //Strategy
          i = i.replace("hp:", "");
          var filteredData = this.state.cardsWithoutFilter.filter(function (
            el
          ) {
            return el.Hp?.toString()
              .toLowerCase()
              .includes(i.toString().trim().toLowerCase());
          });
          multiFilterArray = multiFilterArray.concat(filteredData);
        } else if (i.toString().toLowerCase().includes("fact:")) {
          i = i.replace("fact:", "");
          //Color
          var filteredData2 = multiFilterArray.filter(function (el) {
            return el.CardFaction?.toString()
              .toLowerCase()
              .includes(i.toString().trim().toLowerCase());
          });
          multiFilterArray = filteredData2;
        } else if (i.toString().toLowerCase().includes("cardt:")) {
          //Color requirement
          i = i.replace("cardt:", "");
          var filteredData2 = multiFilterArray.filter(function (el) {
            return el.CardType?.toString()
              .toLowerCase()
              .includes(i.toString().trim().toLowerCase());
          });
          multiFilterArray = filteredData2;
        } else if (i.toString().toLowerCase().includes("cost:")) {
          //Archetype Color Type
          i = i.replace("cost:", "");
          var filteredData2 = multiFilterArray.filter(function (el) {
            return el.Cost?.toString()
              .toLowerCase()
              .includes(i.toString().trim().toLowerCase());
          });
          multiFilterArray = filteredData2;
        } else if (i.toString().toLowerCase().includes("atk:")) {
          //Color
          i = i.replace("atk:", "");
          var filteredData2 = multiFilterArray.filter(function (el) {
            return el.ATK?.toString()
              .toLowerCase()
              .includes(i.toString().trim().toLowerCase());
          });
          multiFilterArray = filteredData2;
        } else if (i.toString().toLowerCase().includes("def:")) {
          //Color Type
          i = i.replace("def:", "");
          var filteredData2 = multiFilterArray.filter(function (el) {
            return el.Def?.toString()
              .toLowerCase()
              .includes(i.toString().trim().toLowerCase());
          });
          multiFilterArray = filteredData2;
        } else if (i.toString().toLowerCase().includes("hp:")) {
          //Strategy
          i = i.replace("hp:", "");
          var filteredData2 = multiFilterArray.filter(function (el) {
            return el.Hp?.toString()
              .toLowerCase()
              .includes(i.toString().trim().toLowerCase());
          });
          multiFilterArray = filteredData2;
        } else if (i.toString().toLowerCase().includes("txt:")) {
          //Cost
          i = i.replace("txt:", "").replace(/"/g, "");
          var filteredData2 = multiFilterArray.filter(function (el) {
            return el.Effect?.toString()
              .toLowerCase()
              .includes(i.toString().trim().toLowerCase());
          });
          multiFilterArray = filteredData2;
        } else if (i.toString().toLowerCase().includes("att:")) {
          //Strategy
          i = i.replace("att:", "").replace(/"/g, "");
          var NameFilterArray = i.split(" ");
          const matchExists = this.state.cardsWithoutFilter.some((item) => {
            const valuesArray = item.ATTRIBUTES.split(",");
            return NameFilterArray.some((searchChar) =>
              valuesArray.includes(searchChar)
            );
          });
          if (matchExists) {
            // If a match exists, create matchingObjects
            filteredData2 = this.state.cardsWithoutFilter.filter((item) => {
              const valuesArray = item.ATTRIBUTES.split(",");
              return NameFilterArray.some((searchChar) =>
                valuesArray.includes(searchChar)
              );
            });
            multiFilterArray = filteredData2;
          }
        }
      });
      this.setState({ cardList: multiFilterArray });
    } else {
      if (NameFilter.toString().toLowerCase().includes("fact:")) {
        NameFilter = NameFilter.replace("fact:", "");
        //Tag
        var filteredData = this.state.cardsWithoutFilter.filter(function (el) {
          return el.CardFaction?.toString()
            .toLowerCase()
            .includes(NameFilter.toString().trim().toLowerCase());
        });
      } else if (NameFilter.toString().toLowerCase().includes("cardt:")) {
        //Card Type
        NameFilter = NameFilter.replace("cardt:", "");
        var filteredData = this.state.cardsWithoutFilter.filter(function (el) {
          return el.CardType?.toString()
            .toLowerCase()
            .startsWith(NameFilter.toString().trim().toLowerCase());
        });
      } else if (NameFilter.toString().toLowerCase().includes("cost:")) {
        //Archtype Color Type
        NameFilter = NameFilter.replace("cost:", "");
        var filteredData = this.state.cardsWithoutFilter.filter(function (el) {
          return el.Cost?.toString()
            .toLowerCase()
            .includes(NameFilter.toString().trim().toLowerCase());
        });
      } else if (NameFilter.toString().toLowerCase().includes("atk:")) {
        //Color
        NameFilter = NameFilter.replace("atk:", "");
        var filteredData = this.state.cardsWithoutFilter.filter(function (el) {
          return el.ATK?.toString()
            .toLowerCase()
            .includes(NameFilter.toString().trim().toLowerCase());
        });
      } else if (NameFilter.toString().toLowerCase().includes("def:")) {
        //Color Type
        NameFilter = NameFilter.replace("def:", "");
        var filteredData = this.state.cardsWithoutFilter.filter(function (el) {
          return el.Def?.toString()
            .toLowerCase()
            .includes(NameFilter.toString().trim().toLowerCase());
        });
      } else if (NameFilter.toString().toLowerCase().includes("hp:")) {
        //HP
        NameFilter = NameFilter.replace("hp:", "");
        var filteredData = this.state.cardsWithoutFilter.filter(function (el) {
          return el.Hp?.toString()
            .toLowerCase()
            .includes(NameFilter.toString().trim().toLowerCase());
        });
      } else if (NameFilter.toString().toLowerCase().includes("att:")) {
        //Strategy
        NameFilter = NameFilter.replace("att:", "").replace(/"/g, "");
        var NameFilterArray = NameFilter.split(" ");
        const matchExists = this.state.cardsWithoutFilter.some((item) => {
          const valuesArray = item.ATTRIBUTES.split(",");
          return NameFilterArray.some((searchChar) =>
            valuesArray.includes(searchChar)
          );
        });
        if (matchExists) {
          // If a match exists, create matchingObjects
          filteredData = this.state.cardsWithoutFilter.filter((item) => {
            const valuesArray = item.ATTRIBUTES.split(",");
            return NameFilterArray.some((searchChar) =>
              valuesArray.includes(searchChar)
            );
          });
        } else {
          filteredData = this.state.cardList;
        }
      } else {
        //Default Name/Effect
        var filteredData1 = this.state.cardsWithoutFilter.filter(function (el) {
          return el.NAME?.toString()
            .toLowerCase()
            .includes(NameFilter.toString().trim().toLowerCase());
        });
        var filteredData2 = this.state.cardsWithoutFilter.filter(function (el) {
          return (
            el.Effect?.toString()
              .toLowerCase()
              .includes(NameFilter.toString().trim().toLowerCase()) &&
            !el.NAME?.toString()
              .toLowerCase()
              .includes(NameFilter.toString().trim().toLowerCase())
          );
        });

        var filteredData = filteredData1.concat(filteredData2);
      }
      this.setState({ cardList: filteredData });
    }
  }

  componentDidMount() {
    this.fetchGoogleSheetData();

    this.refreshList();
    var dname = variables.deckName;
    document.getElementById("dName").value = dname;

    if (variables.itemcards.length) {
      this.calcDeckStats();
    }
  }

  fetchGoogleSheetData() {
    const googleSheetLink =
      "https://docs.google.com/spreadsheets/d/e/2PACX-1vRzAXxtY2GJETfmdBUTLGB8BAEzOnPXkTp6Vya4E6uZVDSViqqEQoT4Pt03wbHDHoW3ITsJFBnbJw7B/pub?gid=0&single=true&output=csv";

    Papa.parse(googleSheetLink, {
      download: true,
      header: true,
      complete: (results) => {
        this.setState({
          cardExcel: results.data,
          cardList: results.data,
          cardsWithoutFilter: results.data,
        });
      },
    });
  }

  exportDeck() {
    var list = "";
    //Main Deck
    var deck = variables.deckcards;
    var deckSort = [...new Set(deck.map((item) => item.UniqueName))];
    var deckCardCount = [];
    //Doctrine
    var items = variables.itemcards;
    var itemsSort = [...new Set(items.map((item) => item.UniqueName))];
    var itemCardCount = [];

    list += "Deck Info";
    list += "\r\nDeck Name:";
    list += "\r\n" + document.getElementById("dName").value;

    //Doctrine

    list += "\r\n\r\nDoctrine\r\n";
    var encodeString = "";
    itemsSort.forEach(function (i) {
      itemCardCount.push([
        i,
        items.filter((obj) => obj.UniqueName === i.toString()).length,
      ]);
      encodeString += i + " - Doctrine";
      list += "\r\n" + i;
    });

    //Main Deck Cards
    list += "\r\n\r\nMaindeck Cards\r\n";

    deckSort.forEach(function (i) {
      deckCardCount.push([
        i,
        deck.filter((obj) => obj.UniqueName === i.toString()).length,
      ]);
      encodeString += "\r\n" + i;
      encodeString +=
        " ^ " + deck.filter((obj) => obj.UniqueName === i.toString()).length;
      list += "\r\n" + i;
      list +=
        " - " + deck.filter((obj) => obj.UniqueName === i.toString()).length;
    });
    encodeString = btoa(encodeString);

    list = list + "\r\n" + "Deck List String: " + "\r\n" + encodeString;
    var modal = document.getElementById("myModal");

    var span = document.getElementById("modalText");
    modal.style.display = "block";
    span.value = list;
  }

  shuffle(array) {
    let currentIndex = array.length,
      randomIndex;

    // While there remain elements to shuffle.
    while (currentIndex != 0) {
      // Pick a remaining element.
      randomIndex = Math.floor(Math.random() * currentIndex);
      currentIndex--;

      // And swap it with the current element.
      [array[currentIndex], array[randomIndex]] = [
        array[randomIndex],
        array[currentIndex],
      ];
    }

    return array;
  }

  importDeck() {
    this.state.ICards = [];
    this.state.DCards = [];
    variables.itemcards = [];
    variables.deckcards = [];

    var unencodeString = document
      .getElementById("importText")
      .value.replaceAll("’", "'");

    var textDeckList = atob(unencodeString);
    var lines = textDeckList.split("\n");

    //assests

    for (let i = 0; i < lines.length; i++) {
      if (lines[i]) {
        var lName = lines[i].toString().toLowerCase();
        var item = "";
        var itemName = lName;
        var itemCount = 1;
        if (lName.toString().includes(" - doctrine")) {
          item = lines[i].toString().toLowerCase().replace(" - doctrine", "");
          itemName = item.toString().trim().replaceAll("\r", "");
          itemCount = 1;
        } else {
          item = lines[i].toString().toLowerCase().split(" ^ ");
          itemName = item[0].toString().trim().replaceAll("\r", "");
          itemCount = item[1];
        }

        for (let i = 0; i < itemCount; i++) {
          this.addCardtoArray(itemName.toString());
        }
      }
    }

    var modal = document.getElementById("importDeck");
    var span = document.getElementById("importText");
    modal.style.display = "none";
  }

  drawHand() {
    this.setState({ firstHand: [] });
    var item = this.state.ICards;
    var handSize = item[0].HS;
    var deck = this.state.DCards;
    var firsthan = [];

    deck.forEach(function (card, inc) {
      firsthan.push({ key: uuid(), URLLINK: deck[inc].URLLINK });
    });

    this.shuffle(firsthan);

    firsthan.length = handSize || 5;

    this.setState({ firstHand: firsthan });
    this.sortCardResult(document.getElementById("sortSelect").value);
  }

  closeModal() {
    var modal = document.getElementById("myModal");
    var modal2 = document.getElementById("myModal2");
    var modal3 = document.getElementById("importDeck");
    var modal4 = document.getElementById("testHand");
    var modal5 = document.getElementById("deckBuildDisplay");
    this.setState({ firstHand: [] });
    modal.style.display = "none";
    modal2.style.display = "none";
    modal3.style.display = "none";
    modal4.style.display = "none";
    modal5.style.display = "none";
  }

  showTips() {
    var modal = document.getElementById("myModal2");

    modal.style.display = "block";
  }

  hideItems() {
    var ddisplay = document.getElementById("divItemDisplay");

    ddisplay.classList.toggle("hide");
  }

  hideDeck() {
    var ddisplay = document.getElementById("divDeckDisplay");

    ddisplay.classList.toggle("hide");
  }

  copyText() {
    /* Get the text field */
    var copyText = document.getElementById("modalText");

    /* Select the text field */
    copyText.select();
    copyText.setSelectionRange(0, 99999); /* For mobile devices */

    /* Copy the text inside the text field */
    navigator.clipboard.writeText(copyText.value);

    /* Alert the copied text */
    //alert("Copied the text: " + copyText.value);
  }

  showImport() {
    var modal3 = document.getElementById("importDeck");

    modal3.style.display = "block";
  }

  showTestHand() {
    var modal3 = document.getElementById("testHand");

    modal3.style.display = "block";
  }

  showDeckRules() {
    var ddisplay = document.getElementById("deckBuildDisplay");

    ddisplay.style.display = "block";
  }

  saveDeckname(e) {
    variables.deckName = e.target.value;
  }

  handleChangeSort = (event) => {
    this.sortCardResult(event.target.value);
  };

  handleChangeASC = () => {
    this.sortResult(document.getElementById("sortSelect").value, true);
  };

  showDeckStats() {
    var ddisplay = document.getElementById("deckInfoDisplay");

    ddisplay.classList.toggle("hide");
  }

  saveDeck() {
    var item = variables.itemcards;
    var deck = variables.deckcards;
    var deckName = document.getElementById("dName").value || "WarcasteDeck";
    var deckData = DeckExport(this.state.cardExcel, [...item, ...deck]);

    const deckDataJson = JSON.stringify(deckData, null, 2);
    const blob = new Blob([deckDataJson], { type: "application/json" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = deckName + ".json";
    link.click();
    URL.revokeObjectURL(url);

    console.log(deckData);
  }

  handleChangeDESC = () => {
    this.sortResult(document.getElementById("sortSelect").value, false);
  };

  render() {
    const { cardList, cardExcel, firstHand } = this.state;

    return (
      <>
        <div className="flex-container wide100per">
          <div id="dList" className="flex-container wide25per">
            <div className="flex-container wide100per">
              <div
                className="flex-container card borderBottomGray wide100per navbar colorBlack navbar-expand-sm navbar-dark"
                id="start"
              >
                <div className="pl5px pt10px wide100per">
                  <div className="gridRow2 gridCol1">
                    <input
                      id="dName"
                      placeholder="Deck Name..."
                      className="wide100per"
                      type="text"
                      title="Name of the Exported deck."
                      onChange={this.saveDeckname}
                    ></input>
                  </div>
                  <div className="cardDock mt5px pt5px pb5px">
                    <div className="gridRow1 posRel gridCol1">
                      <span className="posAbso deckCountStyle fs22pt pt12px">
                        <span
                          className="deckCountStyle fs22pt pt12px pr3px"
                          id="cardCount"
                        >
                          0
                        </span>
                      </span>
                      <img
                        title="Cards in Deck."
                        src="./assets/images/Symbols/DeckCountermid.png"
                        className="imgNoRadius"
                      />
                    </div>
                  </div>
                  <label>
                    <button
                      className="btn-sm removeBtn"
                      onClick={() => this.showDeckStats()}
                      title="Click to see additional deck information."
                    >
                      <FontAwesomeIcon icon={faEyeSlash} />
                    </button>
                  </label>
                  <label>
                    <button
                      className="btn-sm removeBtn"
                      onClick={() => this.showDeckRules()}
                      title="Click to see deck building rules."
                    >
                      <FontAwesomeIcon icon={faQuestionCircle} />
                    </button>
                  </label>
                </div>
                <div className="pl5px pt10px  wide100per">
                  <div id="deckInfoDisplay" className="card-body hide">
                    <div className="gridRow1 gridCol12 wide100per pb5px pt10px">
                      <h5 className="card-title">Deck Information </h5>
                    </div>
                    <div className="gridRow2 gridCol1 wide100per pb5px pt10px">
                      <div id="divDeckStats"></div>
                    </div>
                    <div className="gridRow4 wide100per pb5px pt10px">
                      <input
                        type="button"
                        className="card-link"
                        value="Export"
                        id="myBtn"
                        onClick={() => this.exportDeck()}
                      />
                      <input
                        type="button"
                        className="card-link"
                        value="Import"
                        id="myBtn2"
                        onClick={() => this.showImport()}
                      />
                      <input
                        type="button"
                        className="card-link"
                        value="Test Hand"
                        id="myBtn3"
                        onClick={() => this.showTestHand()}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="h65vh overflwScroll hFC wide100per">
                <div className="borderBottomGray pb5px wide100per">
                  <div id="divItemDisplay">
                    {" "}
                    &nbsp;&nbsp;Doctrine
                    <br />
                    {
                      //MC
                      this.state.itemDisplay.map((ic) => (
                        <div className="cardDock" key={ic.URLLINK}>
                          <div className="textRight gridRow1 gridColumn12">
                            <ImageComponent
                              imgClass="wide211px partialCard"
                              imgURL={ic.URLLINK}
                            ></ImageComponent>
                            <br />
                          </div>
                          <div className="gridRow1 gridColumn3">
                            <button
                              className="btn btn-dark btn-outline-secondary"
                              onClick={() =>
                                this.removeItemfromArray(ic.UniqueName)
                              }
                            >
                              <FontAwesomeIcon icon={faSquareMinus} />
                            </button>
                          </div>
                        </div>
                      ))
                    }
                  </div>
                </div>
                <div id="divDeckDisplay">
                  {
                    //Deck
                    this.state.deckDisplay.map((dc) => (
                      <div className="cardDock" key={dc.URLLINK}>
                        <div className="textRight gridRow1 gridColumn12">
                          <ImageComponent
                            imgClass={"wide211px partialCard " + dc.CardType}
                            imgURL={dc.URLLINK}
                          ></ImageComponent>
                        </div>
                        <div className="gridRow1 gridColumn3">
                          Count: {dc.Count}
                          <br />
                          <button
                            className="btn btn-dark btn-outline-secondary"
                            onClick={() =>
                              this.removeCardfromArray(dc.UniqueName)
                            }
                          >
                            <FontAwesomeIcon icon={faSquareMinus} />
                          </button>
                          <button
                            className="btn btn-dark btn-outline-secondary"
                            onClick={() => this.addCardtoArray(dc.UniqueName)}
                          >
                            <FontAwesomeIcon icon={faSquarePlus} />
                          </button>
                        </div>
                      </div>
                    ))
                  }
                </div>
              </div>
            </div>
          </div>
          <div
            id="cList"
            className="flex-container wide75per pl10px floatRight"
          >
            <div className="flex-container wide100per floatRight h92vh overflwScroll">
              <div className="posAbosolutez10 colorBG wide73per pt10px">
                <input
                  className="btn btn-dark btn-outline-secondary"
                  value={this.state.NameFilter || ""}
                  onChange={this.changeNameFilter}
                />
                <button
                  type="button"
                  className="btn-dark btn-danger btn-outline-danger"
                  onClick={() => this.refreshList()}
                >
                  Reset
                </button>
                <input
                  className="btn-dark btn-danger btn-outline-danger"
                  type="button"
                  value="Filter tips"
                  id="myBtn2"
                  onClick={() => this.showTips()}
                />
              </div>
              <div className="flex-container pt70px pl-10">
                {cardList.map((dep) => (
                  <div className="wide14rem h365px" key={dep.UniqueName}>
                    <div>
                      {dep.NAME}
                      <br />
                      <ImageComponent
                        imgClass="wide211px h295px"
                        imgURL={dep.URLLINK}
                      ></ImageComponent>
                    </div>
                    <input
                      type="button"
                      value="Add 1 Copy"
                      className="btn-dark btn-danger btn-outline-danger"
                      onClick={() => this.addCardtoArray(dep?.UniqueName)}
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
        <div id="myModal" className="modal">
          <div className="modal-content">
            <span className="close" onClick={() => this.closeModal()}>
              &times;
            </span>
            <textarea id="modalText" className="h365px"></textarea>
            <button onClick={() => this.copyText()}>Copy text</button>
            <button onClick={() => this.saveDeck()}>Export to TTS</button>
          </div>
        </div>
        <div id="myModal2" className="modal">
          <div className="modal-content wideMC">
            <span className="close" onClick={() => this.closeModal()}>
              &times;
            </span>
            <span id="modalText2" className="textLeft">
              The filters use a character and a semi-colon to create more
              complex search results. You can use multiple filters at once, just
              seperate them with commas (Atk:4,Cost:2).
              <br />
              Otherwise, just typing will filter for a card name and/or card
              effect.
              <br />
              <br />
              fact: Will filter for Factions of the card: Corinth, Karnage,
              Psiker, Ramus.
              <br />
              (fact:Corinth)
              <br />
              <br />
              cardt: Will filter for Card Types: Doctrine, Tactic, Territory,
              Trap, Unit.
              <br />
              (CardT:Doctrine)
              <br />
              <br />
              cost: Will filter for the cost of the Card.
              <br />
              (cost:2)
              <br />
              <br />
              atk: Will filter for the power of a Card.
              <br />
              (atk:2)
              <br />
              <br />
              def: Will filter for the def of a Card.
              <br />
              (def:2)
              <br />
              <br />
              hp: Will filter for the HP of a Card.
              <br />
              (hp:2)
              <br />
              <br />
              att:"" Will search in the attributes of a card, the attributes are
              the following:
              <br />
              <span className="displayGrid">
                <span className="gridRow1">d</span>
                <span className="gridRow2">
                  <img
                    className="imgNoRadius"
                    src="https://media.discordapp.net/attachments/1111769204228640849/1165539309307301958/Destructive.png?ex=65473812&is=6534c312&hm=1fe3fbcfe1b30120446c22e56970fcb7b28e2e9faeaece74b0fffebf784b5f70&="
                  />
                </span>
                <span className="gridRow1">i</span>
                <span className="gridRow2">
                  <img
                    className="imgNoRadius"
                    src="https://media.discordapp.net/attachments/1111769204228640849/1174532038712373369/Intelegence.png?ex=659613b3&is=65839eb3&hm=ead5d39fc318594cfe577838462b9a963e951a0b38af0c92626d976910bd1c5b&=&format=webp"
                  />
                </span>
                <span className="gridRow1">p</span>
                <span className="gridRow2">
                  <img
                    className="imgNoRadius"
                    src="https://media.discordapp.net/attachments/1111769204228640849/1165539309844189205/Passive.png?ex=65473812&is=6534c312&hm=8a7827aaf3a9fd157eaa839d44140acca5a77b0be839584f56179ed4706ccf24&="
                  />
                </span>
                <span className="gridRow1">s</span>
                <span className="gridRow2">
                  <img
                    className="imgNoRadius"
                    src="https://media.discordapp.net/attachments/1111769204228640849/1165539310120996924/Swarm.png?ex=65473812&is=6534c312&hm=6df96a6c2a928449c4c163332da1f0ce89e13a6194db31562744c40311df3e99&="
                  />
                </span>
                <span className="gridRow1">t</span>
                <span className="gridRow2">
                  <img
                    className="imgNoRadius"
                    src="https://media.discordapp.net/attachments/1111769204228640849/1165539310376861746/Targeting.png?ex=65473812&is=6534c312&hm=b13d2de2c1710b323eb4d9db9a6ec76fe6c0e6e2b70ce052f9679c3dad398327&="
                  />
                </span>
              </span>
              <br />
              (att:"D P")
              <br />
              <br />
              txt:"" Will search the text of a card. This is only usable when
              you are using multiple search parameters.
              <br />
              (hp:1,txt:"would")
              <br />
              <br />
            </span>
          </div>
        </div>
        <div id="importDeck" className="modal">
          <div className="modal-content wide30vwimp">
            <span className="close" onClick={() => this.closeModal()}>
              &times;
            </span>
            <textarea id="importText"></textarea>
            <button onClick={() => this.importDeck()}>import Deck</button>
          </div>
        </div>

        <div id="deckBuildDisplay" className="modal">
          <div className="modal-content">
            <span className="close" onClick={() => this.closeModal()}>
              &times;
            </span>
            <img
              className="imgNoRadius wide500px"
              src="./assets/images/Deck_Building.png"
            />
          </div>
        </div>

        <div id="testHand" className="modal">
          <div className="modal-content wide80perImp">
            <span className="close" onClick={() => this.closeModal()}>
              &times;
            </span>
            <div className="flex-container">
              {firstHand.map((fhan) => (
                <div key={fhan.key}>
                  <div>
                    <ImageComponent
                      imgClass="wide211px h295px"
                      imgURL={fhan.URLLINK}
                    ></ImageComponent>
                  </div>
                </div>
              ))}
            </div>
            <button className="mwide350" onClick={() => this.drawHand()}>
              Draw Hand
            </button>
          </div>
        </div>
      </>
    );
  }
}
